import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { PaceNotificationCardComponent } from '../pace-notification-card/pace-notification-card.component';
import {
    PaceNotificationCard,
    PaceNotificationSeverity,
} from '../pace-notification-card/pace-notification-card.interface';

/** Left border color per severity — the list's at-a-glance indicator for the equipment state. */
const SEVERITY_BORDER_CLASSES: Record<PaceNotificationSeverity, string> = {
    down: 'border-red',
    partiallyDown: 'border-orange',
    working: 'border-green',
    unknown: '',
};

/**
 * One column of dashboard notification cards, with a heading and a fallback text for the empty
 * case.
 *
 * `count` is separate from `cards.length` on purpose: a host may render fewer cards than the
 * column holds (the dashboard hides notifications whose cancellation has been confirmed), and
 * the heading still reports the full count.
 */
@Component({
    selector: 'pace-notification-card-list',
    imports: [PaceNotificationCardComponent],
    templateUrl: './pace-notification-card-list.component.html',
    styleUrls: ['./pace-notification-card-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaceNotificationCardListComponent {
    public readonly cards = input.required<PaceNotificationCard[]>();
    /** Number shown next to the heading. Also decides whether the empty text is shown. */
    public readonly count = input.required<number>();
    /** Heading of the column. Only rendered on large screens; empty on small ones. */
    public readonly title = input('');
    /** Translated text shown when the column is empty. */
    public readonly emptyText = input('');

    public readonly cardSelect = output<PaceNotificationCard>();

    public borderClass(card: PaceNotificationCard): string {
        return SEVERITY_BORDER_CLASSES[card.severity];
    }
}
